import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../Layout/LeftSide';
import RightSide from '../Layout/RightSide';
import { useTheme } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { setSuitPartsList } from '../redux/Slices/MainSlice';

 
 

function Home() {
 
    
 
    return (
    <>
        <Row className='addColumnReverse'>
            <Col lg={6}>
                <LeftSide />
            </Col>
            <Col lg={6}>
                <RightSide  />
            </Col>
        </Row>
    </>
    );
}

export default Home;